export default __webpack_public_path__ + "static/media/icon.280f759b.png";